import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-300 ${
        scrolled
          ? "bg-[#FDFBF7]/85 backdrop-blur-xl shadow-[0_1px_0_0_#E8E1D9]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="font-display text-2xl lg:text-3xl text-[#2B2623] tracking-tight"
        >
          mamy<span className="text-[#E6007A]">!</span>kongres
        </Link>

        <nav className="hidden xl:flex items-center gap-4">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium whitespace-nowrap rounded-full px-2.5 py-1.5 -mx-2.5 -my-1.5 transition-[background-color,color] duration-200 ${
                  isActive ? "text-[#E6007A] bg-[#FDDAE3]" : "text-[#2B2623] hover:text-[#E6007A] hover:bg-[#FDDAE3]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden xl:block">
          <Link
            to="/zapisz-sie"
            data-testid="nav-cta-register"
            className="btn-lift inline-flex items-center whitespace-nowrap rounded-full bg-[#E6007A] px-6 py-3 text-white text-sm font-semibold"
          >
            Zapisz się
          </Link>
        </div>

        <button
          className="xl:hidden p-2 rounded-full hover:bg-[#F4EFE6] transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="xl:hidden bg-[#FDFBF7] border-t border-[#E8E1D9]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`m-${l.testid}`}
                className={({ isActive }) =>
                  `text-base rounded-xl px-3 py-2 -mx-3 transition-[background-color,color] duration-200 ${
                    isActive ? "text-[#E6007A] bg-[#FDDAE3]" : "text-[#2B2623] hover:text-[#E6007A] hover:bg-[#FDDAE3]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/zapisz-sie"
              data-testid="m-nav-cta-register"
              className="mt-2 inline-flex justify-center rounded-full bg-[#E6007A] px-6 py-3 text-white text-sm font-semibold"
            >
              Zapisz się
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
